import { createContext, useContext } from 'react';

import { userContextValue } from './constants';

const UserContext = createContext(userContextValue);

export const useUserContext = () => useContext(UserContext);

export default UserContext;
